<template>
  <div>
    <template v-if="value">
      <v-icon @click.stop="$emit('cancel')">mdi-close-circle</v-icon>
      <v-icon @click.stop="$emit('save')">mdi-content-save-edit</v-icon>
    </template>
    <v-icon @click.stop="$emit('input', true)" v-else>mdi-pencil</v-icon>
  </div>
</template>

<script>
export default {
  props: ['value']
}
</script>
